"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("./components");
var Modal = function (_a) {
    var children = _a.children, closable = _a.closable, footer = _a.footer, footerAlign = _a.footerAlign, onClose = _a.onClose, open = _a.open, _b = _a.scrollable, scrollable = _b === void 0 ? true : _b, size = _a.size, title = _a.title, focusScopeOptions = _a.focusScopeOptions, rest = __rest(_a, ["children", "closable", "footer", "footerAlign", "onClose", "open", "scrollable", "size", "title", "focusScopeOptions"]);
    return open && (react_1.default.createElement(components_1.ModalWindow, __assign({ closable: closable, onClose: closable && onClose, size: size, focusScopeOptions: focusScopeOptions }, rest),
        react_1.default.createElement(components_1.ModalHeader, { closable: closable, title: title, onClose: onClose }),
        react_1.default.createElement(components_1.ModalContent, { className: "fs-3", scrollable: scrollable }, children),
        footer && react_1.default.createElement(components_1.ModalFooter, { align: footerAlign }, footer)));
};
exports.Modal = Modal;
exports.Modal.Window = components_1.ModalWindow;
exports.Modal.Header = components_1.ModalHeader;
exports.Modal.Content = components_1.ModalContent;
exports.Modal.Footer = components_1.ModalFooter;
exports.Modal.Sizes = components_1.ModalSizes;
//# sourceMappingURL=Modal.js.map